import { EditorContent, useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import { Table, TableCell, TableHeader, TableRow } from '@tiptap/extension-table';
import { Markdown } from '@tiptap/markdown';

/**
 * @graph-node {Function}
 * @graph-stack ac-mens-hub
 * @graph-domain Engineering
 * @graph-business Markdown の本文（売上集計の定義の正本など）を読み取り専用で表示するコンポーネント。週次レポートと同じ tiptap の拡張で表・見出し・コードを描き、HTML 文字列を直接挿入しないため XSS の経路を作らない。
 * @graph-connects none
 */
export function MarkdownContent({ markdown }: { markdown: string }) {
  const editor = useEditor(
    {
      editable: false,
      extensions: [
        StarterKit.configure({ link: { openOnClick: true } }),
        Table.configure({ resizable: false }),
        TableRow,
        TableHeader,
        TableCell,
        Markdown,
      ],
      content: markdown,
      contentType: 'markdown',
      editorProps: {
        attributes: { class: 'report-prose max-w-none text-[var(--color-text-primary)]' },
      },
    },
    // 版を切り替えたら本文を読み直す（tiptap は content の変化だけでは作り直さない）
    [markdown],
  );

  return <EditorContent editor={editor} />;
}
